import styled, { css, keyframes } from 'styled-components';
import { getColor, getColorShade, getSizeBy } from '../../../src/styled/utils';
const getDotColor = (props) => {
    if (props.color) {
        return props.colorShade
            ? getColorShade(props.color, props.colorShade)({ theme: props.theme })
            : getColor(props.color)({ theme: props.theme });
    }
    return getColor('onSurface')({ theme: props.theme });
};
const getDotLowEmphasisColor = (props) => {
    if (props.color) {
        return getColorShade(props.color, 'lowEmphasis')({ theme: props.theme });
    }
    return getColorShade('onSurface', 'lowEmphasis')({ theme: props.theme });
};
const pulse = (props) => keyframes `
  0% {
    background-color: ${getDotColor(props)};
  }

  50%,
  100% {
    background-color: ${getDotLowEmphasisColor(props)};
  }
`;
const pulseAnimationCSS = css `
  ${(props) => !props.disableAnimation &&
    css `
      animation-name: ${pulse({
        theme: props.theme,
        color: props.color,
        colorShade: props.colorShade
    })};
      animation-duration: ${props.animationDuration || 1}s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-direction: alternate;
    `}
`;
export const StyledDot = styled.span `
  ${pulseAnimationCSS};
  display: inline-block;
  width: ${(props) => getSizeBy(props.size || 0.75)};
  height: ${(props) => getSizeBy(props.size || 0.75)};
  background-color: ${(props) => getDotColor({ theme: props.theme, color: props.color, colorShade: props.colorShade })};
  border-radius: 50%;
`;
export const StyledLoadingIndicator = styled.div `
  display: flex;
  gap: ${(props) => getSizeBy(props.gap || 1)};
  align-self: center;
  padding: ${getSizeBy(0.5)};
  text-align: center;
  vertical-align: middle;

  & > ${StyledDot}:nth-child(1) {
    animation-delay: 0s;
  }
  & > ${StyledDot}:nth-child(2) {
    animation-delay: 0.5s;
  }
  & > ${StyledDot}:nth-child(3) {
    animation-delay: 1s;
  }
`;
